
import React from 'react'
import { useEffect } from 'react';
import Helper from '../components/Helper';
import {  APPLICATION_JSON } from '../middleware/types';

import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";


function Preview(props) {

    const [showDateForm, setShowDateForm] = React.useState(false)
    const [dateValue, setDateValue] = React.useState("");
    const [showPreviewDate, setShowPreviewDate] = React.useState(false)
    const [getPreviewDate, setGetPreviewDate] = React.useState("");
    
    const [previewDate, setPreviewDate] = React.useState("");
    const handleDate = (event) => {
        setPreviewDate(event.format('YYYY-MM-DD HH-mm-ss a'));
    };
    async function handleReset(event){
        var urlPath = window.location.origin
        var src = window.location.search.replace('?', '')
        var pageURL = urlPath + "/" + src
        console.log("pageURL-----",pageURL)
        var resetDate = ""
        var Url = `https://${window.location.hostname}/set-preview-date?previewDate=${resetDate}`
        console.log("Url-----",Url)
        var response = await Helper.fetchCallFunction(Url, "GET", false, "", JSON.stringify({  }))
        if(response){
        window.location.reload();
        }
    }

    useEffect(() => {
        if (window.location.hostname.startsWith("preview")) {
            setShowPreviewDate(true)
        }
    }, [setShowDateForm])

    const switchDateEdit = (event) => {
        setShowDateForm(true)
    }
    const switchDateEditClose = (event) => {
        setShowDateForm(false)
    }
    function handleDateUpdate(event) {
        setDateValue(event.target.value)
    }
    async function handlePreviewDate(event) {
        var urlPath = window.location.origin
        var src = window.location.search.replace('?', '')
        var pageURL = urlPath + "/" + src
        console.log("pageURL-----",pageURL)
       
        var Url = `https://${window.location.hostname}/set-preview-date?previewDate=${previewDate}`
        console.log("Url-----",Url)
        var response = await Helper.fetchCallFunction(Url, "GET", false, "", JSON.stringify({  }))
        if(response){
        window.location.reload();
        }
        
    }
    useEffect(()=>{
        var urlPath = window.location.origin
        var src = window.location.search.replace('?', '')
         var pageURL = urlPath + "/" + src
        if (window.location.hostname.startsWith("preview")) {
        var url = `/get-preview-date`
        console.log("window.location.hostname----",window.location.hostname)
        fetch(url)
                .then((res) => res.json())
                .then((res) => {
                    setGetPreviewDate(res.previewDate2)
                });
            }
    },[])
    return (
        <>
            {showPreviewDate ?
                <>
                    {showDateForm === false ? <div className='col-lg-12 row' style={{ height: '3rem', backgroundColor: '#acacac', paddingTop: '0.5rem', cursor: 'pointer', zIndex: 2000, position: "relative" }} onClick={switchDateEdit}>
                        <div className="col-lg-6 p-2 d-flex" style={{ height: '3rem', backgroundColor: '#acacac', paddingTop: '0.5rem', cursor: 'pointer', zIndex: 2000, position: "relative" }}>
                        <h5>Click Here To Select Preview Date</h5>
                    </div>
                    <div className='col-lg-6' style={{ height: '3rem', backgroundColor: '#acacac', paddingTop: '0.5rem', cursor: 'pointer', zIndex: 2000, position: "relative" }}>
                    <h5 style={{float:'right'}}>Preview For : {getPreviewDate}</h5>
                    </div></div>
                        :
                        <div className="d-flex justify-content-center" style={{ padding: '0.5rem', zIndex: 2000, position: "relative",backgroundColor:"#acacac" }}>
                            {/* <input type="date" name="previewDate" onChange={(e) => handleDateUpdate(e)}></input>  */}
                            <Datetime inputProps={{ readOnly: true }} initialValue={new Date()} onChange={handleDate} />
                            <button className="btn btn-primary mx-4" style={{ fontSize: "11px", backgroundColor: "#35649A", color: "#fff",  }} onClick={handlePreviewDate}>Submit</button>
                            <button className="btn btn-danger" style={{ fontSize: "11px" }} onClick={switchDateEditClose}>Cancel</button>
                            <button className="btn btn-danger" style={{ fontSize: "11px" , marginLeft : "25px" }} onClick={handleReset}>Reset</button>
                        </div>
                    }
                </> : ""}

            {/* <iframe width="100%" height="100%" src={pageURL} className='iframe-cont'></iframe> */}
        </>)
}

export default Preview

